// TRM data provenance client (/api/trm/sources).
import { get } from "./http";

/** The source registry: what each system feeds and what it is authoritative for. */
export const getSources = () => get("/trm/sources");
